module.exports = __webpack_public_path__ + "static/media/29ADMSPC8.01ead84e.jpg";